import { ActivatedRoute, Route } from "@angular/router";

export class CerRoute {

    public static urlFromActivatedRoute(activatedRoute: ActivatedRoute): string {
        var url : string[] = []
        activatedRoute.snapshot.url.forEach(u => {
            url.push(u.path);
        });
        return url.join('/');
    }
    
    public static urlFromRoute(route: Route): string {
        return route.path;
    }
}
